import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, empty } from 'rxjs';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { map, catchError } from 'rxjs/operators';
import { BaseResponse } from '../models';

@Injectable({
  providedIn: 'root'
})
export class SchoolAndTrainingService {

  constructor(private httpClient: HttpClient) { }

  //#region mechanics school
  public getMechanicsSchoolDetails(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SCHOOL_AND_TRAINING.GET_MECHANICS_SCHOOL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint,body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public registerMechanicsSchool(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SCHOOL_AND_TRAINING.REGISTER_MECHANICS_SCHOOL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#endregion
  //#region modules school
  public getModulesSchoolDetails(body:any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SCHOOL_AND_TRAINING.GET_MODULES_SCHOOL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint,body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public registerModulesSchool(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SCHOOL_AND_TRAINING.REGISTER_MODULES_SCHOOL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#endregion

}
